import React, { useCallback, useState, useRef } from 'react';
import { TextArea } from 'design-system-web';
import { ObjectSchema } from 'yup';
import { validatedControl } from '../../utils/WorkOrder';
import { TextareaAutosizeProps } from 'react-textarea-autosize';

type Props = {
  placeholder: string;
  validationClassName?: string;
  onChange: (value: string) => void;
  style?: TextareaAutosizeProps['style'];
  minRows?: number;
  value: string;
  validation: ObjectSchema<any> | null;
  className?: string;
  maxLength?: number;
  showLengthIndicator?: boolean;
  label?: string;
};

export function ValidatedTextArea({
  placeholder,
  validationClassName,
  onChange,
  minRows = 3,
  value,
  validation,
  className,
  maxLength,
  showLengthIndicator = false,
  style,
  label,
}: Props) {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const validationSequenceRef = useRef(0);

  const handleChange = useCallback(
    async (text: string) => {
      const currentSequence = ++validationSequenceRef.current;

      if (validation) {
        const result = await validatedControl({ value: text }, validation);

        if (currentSequence === validationSequenceRef.current) {
          setSuccess(result.success);
          setError(result.error);
        }
      } else {
        setSuccess(false);
        setError(false);
      }

      onChange(text);
    },
    [validation, onChange]
  );

  return (
    <TextArea
      placeholder={placeholder}
      className={[className, validationClassName].filter(Boolean).join(' ')}
      value={value}
      onChange={handleChange}
      errors={error}
      success={success}
      minRows={minRows}
      maxLength={maxLength}
      showLengthIndicator={showLengthIndicator}
      style={style}
      label={label}
    />
  );
}